import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/features/marketing/seo";
import { RunSheetPage } from "@/features/runsheet/run-sheet-page";
import { t } from "@/i18n";

/** /s/:token — a shared run sheet for vendors and helpers. Public (token + optional passcode), not indexed, stores nothing. */
export const Route = createFileRoute("/s/$token")({
  head: () => noindexHead(t("runsheet.kicker")),
  component: () => {
    const { token } = Route.useParams();
    return <RunSheetPage token={token} />;
  },
});
